import { render } from "./LandingPage.vue?vue&type=template&id=3ea2c635&scoped=true"
const script = {}

import "./LandingPage.vue?vue&type=style&index=0&id=3ea2c635&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea2c635"]])

export default __exports__